/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

export const FinalCtaSection = () => {
  const { secondaryNavigation } = useContext(ContentContext);
  const { t } = useInt();

  return (
    <CtaSection
      theme="dark"
      glow
      title={t('Run it against accounts you already know')}
      description={t(
        "Send us a sample of your portfolio. We'll return it with parent, domestic ultimate, and global ultimate appended — judge the match rate yourself.",
      )}
      actions={
        <>
          {secondaryNavigation?.book_demo?.slug && (
            <Button type="blue" size="xl" route={secondaryNavigation.book_demo.slug}>
              {t('Request a demo')}
            </Button>
          )}

          {secondaryNavigation?.api_access?.slug && (
            <Button type="white-outline" size="xl" route={secondaryNavigation.api_access.slug}>
              {t('Start a match test')}
            </Button>
          )}
        </>
      }
    />
  );
};
